import React from 'react';

import useStyles from './styles';

const PastBids = () => {
    return (
        <h1>Past Bids</h1>
    )
}

export default PastBids;
